import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiClient, POLE_LABELS } from "@/lib/api";

const PolesContext = createContext({ poles: [], poleLabel: (id) => id, reloadPoles: () => {} });

export function PolesProvider({ children }) {
  const [poles, setPoles] = useState([]);

  const reloadPoles = useCallback(async () => {
    try {
      const { data } = await apiClient.get("/poles");
      setPoles(data.filter((p) => p.is_active !== false));
    } catch {
      setPoles([]);
    }
  }, []);

  useEffect(() => { reloadPoles(); }, [reloadPoles]);

  const poleLabel = useCallback(
    (id) => poles.find((p) => p.id === id)?.name || POLE_LABELS[id] || id || "—",
    [poles]
  );

  return (
    <PolesContext.Provider value={{ poles, poleLabel, reloadPoles }}>
      {children}
    </PolesContext.Provider>
  );
}

export const usePoles = () => useContext(PolesContext);
